import React from "react";
import { Link } from "react-router-dom";
import { siteConfig } from "../Datas/productData";
import PolicyNav, { POLICY_UPDATED } from "./PolicyNav";
import "../css/privacy.scss";

export default function Payments() {
  return (
    <main className="policy-page privacy">
      <header className="policy-hero policy-hero--legal">
        <p className="policy-eyebrow">Customer care</p>
        <h1>Payments &amp; pricing</h1>
        <p>
          How prices, payment authorization, taxes, discounts, and refunds work
          at {siteConfig.brandName}.
        </p>
        <span>Effective {POLICY_UPDATED}</span>
      </header>

      <div className="policy-layout">
        <PolicyNav current="/payments" />

        <article className="policy-content policy-content--legal">
          <section className="policy-intro" aria-labelledby="payments-overview">
            <p className="policy-eyebrow">Secure checkout</p>
            <h2 id="payments-overview">Transparent totals, hosted payment.</h2>
            <p>
              Your order total is shown before payment. Card details are entered
              on an independent payment provider’s hosted page and are not stored
              by this storefront.
            </p>
          </section>

          <section className="policy-section" aria-labelledby="payments-methods">
            <div className="policy-section__heading">
              <span>01</span>
              <h2 id="payments-methods">Available payment methods</h2>
            </div>
            <p>
              The hosted checkout displays the cards, wallets, or other methods
              available for your order. Availability may depend on the provider,
              device, billing country, currency, and risk checks. A listed method
              is not guaranteed to remain available for every transaction.
            </p>
          </section>

          <section className="policy-section" aria-labelledby="payments-authorization">
            <div className="policy-section__heading">
              <span>02</span>
              <h2 id="payments-authorization">Authorization &amp; order acceptance</h2>
            </div>
            <p>
              When you submit payment, the provider may authorize the order
              amount and perform fraud or address checks. An authorization can
              appear as pending even if an order is later declined or cancelled;
              your bank controls when that hold disappears. Payment success does
              not require us to accept an order containing an obvious error or an
              unavailable item. Any captured amount for a cancelled item will be
              refunded to the original method.
            </p>
          </section>

          <section className="policy-section" aria-labelledby="payments-prices">
            <div className="policy-section__heading">
              <span>03</span>
              <h2 id="payments-prices">Currency, pricing &amp; corrections</h2>
            </div>
            <p>
              Store prices are displayed and charged in {siteConfig.currency.code}.
              A bank or wallet may apply its own exchange rate or fee. We may
              change prices prospectively and correct a genuine typographical or
              system error. If a correction affects an unfulfilled order, we will
              contact you and provide the option to approve the corrected price
              or cancel the affected item.
            </p>
          </section>

          <section className="policy-section" aria-labelledby="payments-taxes">
            <div className="policy-section__heading">
              <span>04</span>
              <h2 id="payments-taxes">Sales tax, shipping &amp; import charges</h2>
            </div>
            <p>
              Shipping and any sales tax we are required to collect are added to
              the order total before payment. International customs duty, import
              tax, brokerage, and similar destination charges are not included
              unless checkout expressly says otherwise. Those charges are the
              recipient’s responsibility and are governed by local authorities.
            </p>
          </section>

          <section className="policy-section" aria-labelledby="payments-security">
            <div className="policy-section__heading">
              <span>05</span>
              <h2 id="payments-security">Security &amp; declined payments</h2>
            </div>
            <p>
              We receive limited transaction information such as payment status,
              amount, and a provider reference—not your full card number or
              security code. A payment can be declined by the issuer or provider.
              Check the billing details and available funds, then contact your
              bank before trying another method. We may pause or cancel a payment
              for reasonable fraud, sanctions, or security concerns.
            </p>
          </section>

          <section className="policy-section" aria-labelledby="payments-discounts">
            <div className="policy-section__heading">
              <span>06</span>
              <h2 id="payments-discounts">Discounts &amp; promotions</h2>
            </div>
            <p>
              Enter a valid code before paying. Codes may have dates, minimum
              spend, eligible-product, account, region, or one-use restrictions.
              Unless an offer says otherwise, codes cannot be combined, redeemed
              for cash, transferred for resale, or applied to an earlier order.
            </p>
          </section>

          <section className="policy-section" aria-labelledby="payments-refunds">
            <div className="policy-section__heading">
              <span>07</span>
              <h2 id="payments-refunds">Refunds, duplicate charges &amp; disputes</h2>
            </div>
            <p>
              Approved refunds go to the original payment method. See our
              <Link to="/returns"> Returns &amp; Refunds Policy</Link> for eligibility
              and timing. If you see a duplicate or unfamiliar charge, contact us
              promptly so we can investigate before opening a payment dispute.
              This request does not limit any right you have with your issuer.
            </p>
          </section>

          <section className="policy-help" aria-labelledby="payments-help">
            <div>
              <p className="policy-eyebrow">Payment questions</p>
              <h2 id="payments-help">Include your order reference.</h2>
            </div>
            <a href={`mailto:${siteConfig.contact.email}`}>
              Email customer care <span aria-hidden="true">↗</span>
            </a>
          </section>
        </article>
      </div>
    </main>
  );
}
